import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight, Building2 } from "lucide-react";
import { useOrgProfile } from "../../Moduels/Context/OrgProfileContext";

const PAGE_NAME = "Organisation Profile";

const FIELD_LABELS = {
  name: "organisation name",
  pan: "PAN",
  tan: "TAN",
  state: "state",
  address: "address",
};

export default function OrgProfileBanner({ compact = false, className = "" }) {
  const ctx = useOrgProfile();
  if (
    !ctx ||
    ctx.status.loading ||
    ctx.status.profileComplete ||
    !ctx.status.profileEmpty ||
    ctx.noOrganisation
  ) {
    return null;
  }

  const missing = (ctx.status.missingFields || [])
    .filter((f) => f !== "organisation")
    .map((f) => FIELD_LABELS[f] || f)
    .join(", ");

  if (!missing) return null;

  if (compact) {
    return (
      <div className={`op-dash-banner op-dash-banner--compact ${className}`} role="status">
        <AlertTriangle size={16} className="op-dash-banner-icon" aria-hidden />
        <span>
          <strong>{PAGE_NAME}</strong> incomplete ({missing}).{" "}
          {ctx.isAdmin ? (
            <Link to="/onboarding/org-profile" className="op-dash-banner-link">
              Complete {PAGE_NAME}
            </Link>
          ) : (
            "Ask your admin to complete company details."
          )}
        </span>
      </div>
    );
  }

  return (
    <div className={`op-dash-banner ${className}`} role="alert">
      <div className="op-dash-banner-accent" aria-hidden />
      <div className="op-dash-banner-inner">
        <div className="op-dash-banner-icon-wrap">
          <Building2 size={20} aria-hidden />
        </div>
        <div className="op-dash-banner-content">
          <p className="op-dash-banner-kicker">Action required</p>
          <p className="op-dash-banner-title">
            Complete your <span>{PAGE_NAME}</span>
          </p>
          <p className="op-dash-banner-desc">
            Missing: <strong>{missing}</strong>. Payroll, Form 16, and statutory filings need these details.
            {ctx.status.wizardSkipped
              ? " You skipped this earlier — finish it anytime from here."
              : " Complete it when you are ready."}
          </p>
        </div>
        {ctx.isAdmin && (
          <Link to="/onboarding/org-profile" className="op-dash-banner-cta">
            Open {PAGE_NAME}
            <ArrowRight size={15} aria-hidden />
          </Link>
        )}
      </div>
    </div>
  );
}
